export enum PlanningPortalApiUrl {
  GetMasterPlanForMLS = "/api/PlanContainer/GetMasterPlanForMLS",
  GetMasterPlanByLocationAndProduct = "/api/PlanContainer/GetMasterPlanByLocationAndProduct",
  BindLocationWithJobFromMls = "/api/Location/BindLocationWithJobFromMls",
  GetPlansByMasterPlanAndSegment = "/api/PlanContainer/GetPJLByPlanContainer",
  GetPlansByMasterPlanAndLocationId = "/api/PlanContainer/GetPJLByPlanContainerAndLocationId",
  }